import { usePeriodsQuery } from '@/app/services/periodApi';
import { useCreateSharingResultMutation } from '@/app/services/sharignResultApi';
import StandardDialog from '@/components/common/StandardDialog';
import { usePeriod } from '@/components/context/PeriodContext';
import PeriodDetails from '@/components/periodDetails/PeriodDetails';
import PeriodTable from '@/components/tables/PeriodTable';
import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

function Sharing() {
  const { t } = useTranslation(['sharing', 'common']);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(5);

  const { selectedPeriod } = usePeriod();

  const { data } = usePeriodsQuery();

  const [openProcessDialog, setOpenProcessDialog] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);

  const [processSharingResult] = useCreateSharingResultMutation();

  const handleProcess = async () => {
    toast.info(
      t('sent.for.processing', {
        position: toast.POSITION.TOP_RIGHT,
      }),
    );
    const newProcessSharingResult = {
      periodDate: selectedPeriod?.date || '',
    };
    const response = await processSharingResult(newProcessSharingResult);
    if ('data' in response) {
      toast.success(
        t('processed.successfully', {
          position: toast.POSITION.TOP_RIGHT,
        }),
      );
    }
  };

  return (
    <div
      style={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        marginRight: '20px',
        justifyContent: 'space-between',
      }}
    >
      <PeriodDetails />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box sx={{ width: '100%' }}>
          <StandardDialog
            title={t('common:process')}
            contentText={t('common:confirm.process')}
            open={openProcessDialog}
            onClose={() => {
              setButtonDisable(false);
              setOpenProcessDialog(false);
            }}
            onConfirm={() => {
              setOpenProcessDialog(false);
              if (!buttonDisable) {
                setButtonDisable(true);
              }
              handleProcess();
            }}
            cancelText={t('common:no')}
            confirmText={t('common:yes')}
          />
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography
              sx={{
                fontWeight: 'bold',
                fontSize: '20px',
                color: '#4b4b4b',
                marginTop: '32px',
              }}
            >
              {t('common:sharing')}
            </Typography>
            <Box sx={{ display: 'flex', marginTop: '40px' }}>
              <Button
                onClick={() => {
                  setOpenProcessDialog(true);
                }}
                variant="primary"
                style={{
                  marginLeft: '16px',
                }}
              >
                {t('common:process')}
              </Button>
            </Box>
          </Box>
        </Box>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '2rem',
          width: '100%',
        }}
      >
        <PeriodTable
          rows={data?.content || []}
          page={page}
          setPage={setPage}
          count={data?.totalElements as number}
          rowsPerPage={size}
          setRowsPerPage={setSize}
        />
      </div>
    </div>
  );
}
export default Sharing;
